module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryoutgroup-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_vm._v("\n    " + _vm._s(_vm.source ? '' : '') + "\n    "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/video'
      }
    }
  }, [_vm._v("Video Pembelajaran")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Upload")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Upload Video")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [(_vm.modul != null) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Modul Name *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.modul.name
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("URL Video *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Masukkan URL Video dan tekan enter",
      "required": ""
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "keydown": function($event) {
        return _vm.hideForm()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.changeUrl) ? _c('span') : _vm._e(), _vm._v(" "), (_vm.changeUrl) ? _c('button', {
    staticClass: "btn btn-success pull-left mb-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.checkURL()
      }
    }
  }, [_vm._v("Preview URL")]) : _vm._e(), _vm._v(" "), (!_vm.changeUrl) ? _c('youtube', {
    ref: "youtube",
    attrs: {
      "video-id": _vm.videoId
    },
    on: {
      "playing": _vm.playing
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.$route.name === 'VideoMaterialLiveStream') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Mulai")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start_date),
      expression: "start_date"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "startDate",
      "type": "text",
      "name": "start_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start_date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start_time),
      expression: "start_time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "startTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "start_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.start_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start_time = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Berakhir")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end_date),
      expression: "end_date"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "endDate",
      "type": "text",
      "placeholder": "Tanggal",
      "name": "end_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end_time),
      expression: "end_time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "endTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "end_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.end_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_time = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2)])])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.changeUrl) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Source")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.source),
      expression: "source"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.source = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "youtube"
    }
  }, [_vm._v("Youtube")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul Video *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.judul),
      expression: "judul"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": !_vm.$route.query.id && !_vm.$route.query.liveId,
      "placeholder": "Judul Video"
    },
    domProps: {
      "value": (_vm.judul)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.judul = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$route.query.id && !_vm.$route.query.liveId) ? _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.altTitle),
      expression: "altTitle"
    }],
    attrs: {
      "type": "checkbox",
      "name": "alt-title",
      "value": "Bike"
    },
    domProps: {
      "checked": Array.isArray(_vm.altTitle) ? _vm._i(_vm.altTitle, "Bike") > -1 : (_vm.altTitle)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.altTitle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Bike",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.altTitle = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.altTitle = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.altTitle = $$c
        }
      }
    }
  }), _vm._v(" Judul Alternatif\n                          ")]) : _vm._e()]), _vm._v(" "), (_vm.altTitle) ? _c('div', {
    staticClass: "offset-2 col-md-8 col-xs-12 pt-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.judulalt),
      expression: "judulalt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Judul Alternatif",
      "required": _vm.altTitle
    },
    domProps: {
      "value": (_vm.judulalt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.judulalt = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetKelas()
      }]
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('option', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.jenjang) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [(_vm.jenjang === 'SD') ? _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "1") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  1\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "2"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "2") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  2\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "3"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "3") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  3\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "4"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "4") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "4",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  4\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "5"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "5") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "5",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  5\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "6"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "6") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "6",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  6\n                          ")])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "7"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "7") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "7",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  7\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "8"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "8") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "8",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  8\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "9"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "9") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "9",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  9\n                          ")])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "10"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "10") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "10",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  10\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "11"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "11") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "11",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  11\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "12"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "12") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "12",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  12\n                          ")])]) : _vm._e()]), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', {
    staticClass: "col-md-6 class-type"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interest),
      expression: "interest"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SAINTEK"
    }
  }, [_vm._v("IPA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SOSHUM"
    }
  }, [_vm._v("IPS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ALL"
    }
  }, [_vm._v("Semua")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Mata Pelajaran *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mapel),
      expression: "mapel"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mapel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.mapelList), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nama))])
  }), 0)])])]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.changeUrl) ? _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.query.id && !_vm.$route.query.liveId) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Simpan")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("Update")])]) : _vm._e()])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "ok": function($event) {
        return _vm.removeDependency()
      },
      "cancel": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Hapus Pra-Syarat")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("Apakah anda yakin akan menghapus pra-syarat "), _c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.dependencyName))]), _vm._v(" ?")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Upload Video Pembelajaran")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8635d23e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/vd_pembelajaran/Form.vue
// module id = 1377
// module chunks = 0